module.exports = " <div class=\"dv-status-change-history-list\"> <div class=\"row\"> <div class=\"col-sm-12\"> <ul ng-repeat=\"statusChange in vm.sachbearbeiter track by $index\"> <li> <span> {{statusChange.getBesitzerName() | translate}}, </span> <span> {{statusChange.getBesitzer().email}}, </span> <span> {{statusChange.getBesitzer().telefon}} </span> </li> </ul> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/dv-status-change-history-list/dv-status-change-history-list.html
// module id = ZnYd
// module chunks = 0